import { useState } from 'react'
import { DownloadOperatorHoursWorkedExcelRequest } from '@/api/machineryUseRecords/request.types.ts'
import { useMachineryUseRecordsApiClient } from '@/api/machineryUseRecords/useMachineryUseRecordsApiClient.ts'
import { useDownloadExcelFile } from '@/presentation/common/hooks/crud/v2/useDownloadExcelFile.ts'

export const useDownloadReport = () => {
  const repository = useMachineryUseRecordsApiClient()
  const query = useDownloadExcelFile<DownloadOperatorHoursWorkedExcelRequest>({
    filename : 'operator-hours.xlsx',
    callable : repository.downloadOperatorHoursWorkedReport,
    messages : {
      default : 'No se pudo descargar el archivo',
      loading : 'Obteniendo archivo',
      success : 'Archivo descargado',
    },
  })

  const [ data, setData ] = useState<File>()

  const submit = async (req: DownloadOperatorHoursWorkedExcelRequest) => {
    const response = await query.submit(req)
    setData(response)
  }

  return {
    ...query,
    submit,
    data,
  }
}
